import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { UserAgentProvider, withUserAgent } from 'react-ua';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import store from './app/store';
import { Provider } from 'react-redux';
import { DEV_MODE } from './dev/devMode';
const CompWithHoc = withUserAgent(({ ua }) => (
  <CookiesProvider>
    <App ua={ua} />
  </CookiesProvider>
));

const appTree = (
  <Provider store={store}>
    <Router>
      <UserAgentProvider>
        <CompWithHoc />
      </UserAgentProvider>
    </Router>
  </Provider>
);

// On the `/dev` route, wrap the app in the password-gated admin/builder shell.
// DevRoot (the ~946-line builder + mock data) is lazily imported so it ships as
// a separate chunk that real visitors never download — only the /dev route
// fetches it. ponytail: dynamic import, code-split.
const rootEl = document.getElementById('root');
if (DEV_MODE) {
  import('./dev/DevAdmin/DevRoot').then(({ default: DevRoot }) => {
    ReactDOM.render(<DevRoot>{appTree}</DevRoot>, rootEl);
  });
} else {
  ReactDOM.render(appTree, rootEl);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
